import { trimString } from '@/helpers/stringHelpers';
import { Chip } from '../Chip';
import { Box } from '@/components/Box/Box';
import { FiltersChipType } from './helpers';

type ChipsListType = {
  chips: FiltersChipType[];
  onRemoveChip: (chip: FiltersChipType) => void;
};

export const ChipList = ({ chips, onRemoveChip }: ChipsListType) => {
  return (
    <Box display='flex' flexWrap='wrap'>
      {chips.map((chip) => {
        const trimmedLabel = trimString(chip.label, 50);

        return (
          <Chip key={chip.id} title={chip.label} onClick={() => onRemoveChip(chip)} isRemovable={chip.removable}>
            {trimmedLabel}
          </Chip>
        );
      })}
    </Box>
  );
};
